function initGeneratePcModal() {
  const modal = document.getElementById('generate-pc-modal');
  if (!modal) return;

  const radios = modal.querySelectorAll('[data-source-toggle]');
  const nextBtn = modal.querySelector('#modal-next-btn');

  function updateCardSelection() {
    modal.querySelectorAll('[data-source-card]').forEach(card => card.classList.remove('pc-source-card--selected'));
    const checked = modal.querySelector('input[name="source_type"]:checked');
    if (checked) {
      const card = modal.querySelector('[data-source-card="' + checked.value + '"]');
      if (card) card.classList.add('pc-source-card--selected');

      modal.querySelectorAll('[data-source-prereqs]').forEach(el => {
        el.classList.toggle('fr-hidden', el.dataset.sourcePrereqs !== checked.value);
      });
    }
  }

  function updateNextBtn() {
    if (!nextBtn) return;
    const checked = modal.querySelector('input[name="source_type"]:checked');
    const isOcapi = checked?.value === 'ocapi';
    const acknowledged = modal.querySelector('#modal_acknowledged');
    nextBtn.disabled = isOcapi ? !acknowledged?.checked : false;
  }

  radios.forEach(radio => radio.addEventListener('change', () => { updateCardSelection(); updateNextBtn(); }));
  updateCardSelection();
  updateNextBtn();

  const acknowledged = modal.querySelector('#modal_acknowledged');
  if (acknowledged) {
    acknowledged.addEventListener('change', updateNextBtn);
  }

  // Handle next button
  if (nextBtn) {
    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const selectedSource = modal.querySelector('input[name="source_type"]:checked');
      if (!selectedSource) return;

      const urlTemplate = nextBtn.dataset.urlTemplate;
      if (urlTemplate) {
        window.location.href = urlTemplate.replace('__SOURCE__', selectedSource.value);
      }
    });
  }
}

document.addEventListener('turbo:load', initGeneratePcModal);
document.addEventListener('DOMContentLoaded', initGeneratePcModal);
